export const PLP_TRACK_LOCATION = 'product_lister';
export const PDP_TRACK_LOCATION = 'product_detail';
